module.exports = __webpack_public_path__ + "img/Zhomebie02.02565857.png";